
import React from 'react'
import numeral from 'numeral'


export default function Price({ value }) {

	const [dollars, cents] = numeral(value).format('0,0.00').split('.')

	return <span className='price'>
		<span className='priceS'>$</span>
		<span className='priceD'>{dollars}</span>
		<span className='priceC'>.{cents}</span>
	</span>

}